'use client'

import { Fragment, Suspense } from 'react'
import { Skeleton } from '@/components/skeleton'
import { RestaurantDetailBrandLinks } from '@/features/restaurants/restaurant-detail/restaurant-detail-brand-links'
import { RestaurantDetailContentModalVisual } from '@/features/restaurants/restaurant-detail/restaurant-detail-content-modal-visual'
import { useRestaurantDetailContext } from '@/features/restaurants/restaurant-detail/restaurant-detail-context'
import { RestaurantDetailDeals } from '@/features/restaurants/restaurant-detail/restaurant-detail-deals'
import { RestaurantDetailHeader } from '@/features/restaurants/restaurant-detail/restaurant-detail-header'
import { RestaurantDetailVisualsContainer } from '@/features/restaurants/restaurant-detail/restaurant-detail-images/restaurant-detail-images-container'
import { RestaurantDetailInfoSection } from '@/features/restaurants/restaurant-detail/restaurant-detail-info-section'
import { RestaurantDetailMenu } from '@/features/restaurants/restaurant-detail/restaurant-detail-menu/restaurant-detail-menu'
import { RestaurantDetailNavigation } from '@/features/restaurants/restaurant-detail/restaurant-detail-navigation'
import { RestaurantDetailReviews } from '@/features/restaurants/restaurant-detail/restaurant-detail-reviews'
import { RestaurantDetailRewards } from '@/features/restaurants/restaurant-detail/restaurant-detail-rewards'

export const RestaurantDetailContent = () => {
    const { restaurant, citySlug } = useRestaurantDetailContext()

    if (!restaurant) return null

    return (
        <Fragment>
            <div className="flex flex-col items-center w-full relative">
                <div className="flex flex-col items-center w-full relative">
                    <div className="restaurant-detail-inner-container mt-4 md:mt-8">
                        <RestaurantDetailHeader />
                    </div>
                </div>

                <RestaurantDetailVisualsContainer
                    visuals={restaurant.visuals}
                    className="mt-4 md:mt-8"
                />

                {/* Only the tab bar sticks, the header above scrolls away. On mobile it
                    sits below the fixed 64px site navigation */}
                <div
                    className="flex flex-col items-center w-full sticky top-16 md:top-0 bg-bg-neutral-base
                        mt-4 md:mt-8 mb-8 md:mb-12 z-[3]"
                >
                    {/* Bottom-aligned hairline instead of a border so the selected tab's
                        underline sits on the same line and covers it, like in the design */}
                    <div className="absolute inset-x-0 bottom-0 h-[1px] bg-border-primary" />

                    <div className="w-full overflow-x-auto scrollbar-hide">
                        <div className="restaurant-detail-scroller-content">
                            <RestaurantDetailNavigation />
                        </div>
                    </div>
                </div>

                <div className="restaurant-detail-inner-container pb-20">
                    <RestaurantDetailDeals />
                    <RestaurantDetailRewards />

                    <Suspense fallback={<Skeleton className="w-full h-20" />}>
                        <div className="w-full">
                            <RestaurantDetailMenu />
                        </div>

                        <RestaurantDetailReviews />

                        <RestaurantDetailInfoSection />
                        <RestaurantDetailBrandLinks />
                    </Suspense>
                </div>
            </div>

            <Suspense fallback={null}>
                <RestaurantDetailContentModalVisual restaurant={restaurant} citySlug={citySlug} />
            </Suspense>
        </Fragment>
    )
}
